import settingsTemplate from './settings.html';

export default angular
  .module('main.notifications.groups.edit.tabs.settings', [])

  .directive('editNotificationGroupSettingsTab', () => {
    return {
      restrict: 'E',
      template: settingsTemplate,
      scope: {},
      controller: ($scope,
                   $rootScope,
                   $q,
                   $filter,
                   utils,
                   config,
                   ToastsService,
                   I18nService,
                   EditNotificationGroupDataProvider) => {
        const $t = $filter('translate');
        const notificationGroupsConfig = config.getConfigByKey('notificationGroups') || [];

        $scope.dataProvider = EditNotificationGroupDataProvider.instance;

        angular.extend($scope, {
          copyToClipboard: $rootScope.copyToClipboard,
          isNotificationsListed: isNotificationsListed,
          enabledNotification: enabledNotification,
          toggleNotificationState: toggleNotificationState,
          hasResults: hasResults,
        });

        init();

        function init() {
          $scope.loading = true;

          $q.all([
            $scope.dataProvider.selectedGroupResource.init(),
            $scope.dataProvider.notificationSettingsResource.init(),
          ])
            .then(() => {
              initNotificationSettings();
            }, () => {
              $scope.loading = false;
            });
        }

        function initNotificationSettings() {
          const locale = I18nService.getLocale();
          const lang = (locale && locale.code) ? locale.code : 'en';

          $scope.groupId = $scope.dataProvider.selectedGroupResource.value?.groupId;
          $scope.notifications = angular.copy($scope.dataProvider.notificationSettingsResource.value || [])
            .map(notification => ({
              ...notification,
              title: resolveLocalized(notification.title, lang),
              description: resolveLocalized(notification.description, lang),
              // Enabled when this group is associated
              enabled: enabledNotification(notification),
            }));

          $scope.notificationGroups = groupNotifications($scope.notifications);
          $scope.loading = false;
        }

        /**
         * Group notifications by notificationId range (see notifications.json).
         * Groups without a min/max ('other') collect anything not matched by a ranged group.
         * Empty groups are omitted.
         * @param {Array} notifications Flat list of notifications
         * @returns {Array} Groups with a `notifications` array
         */
        function groupNotifications(notifications) {
          const rangedGroups = notificationGroupsConfig.filter(group => group.min != null && group.max != null);

          return notificationGroupsConfig
            .map(group => {
              let groupNotifications;
              if (group.min != null && group.max != null) {
                groupNotifications = notifications.filter(notification =>
                  notification.notificationId >= group.min && notification.notificationId <= group.max);
              } else {
                // 'other': anything that doesn't fall into a ranged group
                groupNotifications = notifications.filter(notification =>
                  !rangedGroups.some(ranged =>
                    notification.notificationId >= ranged.min && notification.notificationId <= ranged.max));
              }
              return { ...group, notifications: groupNotifications };
            })
            .filter(group => group.notifications.length);
        }

        /**
         * Whether any notification matches the current search term (across all groups).
         */
        function hasResults() {
          return $filter('filter')($scope.notifications || [], {title: $scope.searchNotificationVal}).length > 0;
        }

        function resolveLocalized(value, lang) {
          if (!value || typeof value === 'string') {
            return value;
          }
          return value[lang] || value.en || value[Object.keys(value)[0]];
        }

        function isNotificationsListed() {
          return !$scope.loading && $scope.notifications && $scope.notifications.length > 0;
        }

        /**
         * Whether the notification is enabled for the current group.
         */
        function enabledNotification(notification) {
          return !!(notification && notification.groups
            && notification.groups.some(group => group.groupId === $scope.groupId));
        }

        function toggleNotificationState(notification) {
          const enable = notification.enabled;
          return $scope.dataProvider.updateNotificationSetting(notification, enable)
            .then(() => {
              initNotificationSettings();
              ToastsService.success(null, enable
                ? $t('notifications.edit.settings.enabledSuccess')
                : $t('notifications.edit.settings.disabledSuccess'));
            })
            .catch(err => {
              // Revert the optimistic toggle on failure
              notification.enabled = !enable;
              return utils.handleApiError(err);
            });
        }

      }
    };
  })
  .name;
